module.exports = {
    "isLoop": true,
    "frames": [
        {
            "time": 0,
            "image": require("@frog/source/assets/images/bomber-tactics/title/start/start1.png").default
        },
        {
            "time": 100,
            "image": require("@frog/source/assets/images/bomber-tactics/title/start/start2.png").default
        },
        {
            "time": 200,
            "image": require("@frog/source/assets/images/bomber-tactics/title/start/start3.png").default
        },
        {
            "time": 300
        }
    ]
}
